<template>
    <section
        v-if="pageLoader"
        class="game-page game-page-loader"
    >
        <div class="page-loader"><button class="button-loader"></button></div>
    </section>
    <section
        v-else
        class="game-page"
        :class="{'game-page-full': fullScreen}"
    >
        <iframe
            :src="getSrc()"
            frameborder="0"
            class="game-iframe"
        ></iframe>
        <div
            @click="toggleFullscreen"
            class="game-toggle"
            :class="{'game-toggle-full': fullScreen}"
        >
            <!-- <span v-if="fullScreen">Свернуть</span>
            <span v-else>Развернуть</span> -->
        </div>
    </section>
</template>

<script>
    export default {
        name: 'Game',
        data() {
            return {
                gameId: null,
                lobbyId: null,
                pageLoader: true,
                urls: {
                    1: 'yes-no',
                    2: 'russian-roulette',
                    3: 'shell-game',
                    4: 'durak'
                },
                fullScreen: false,
                src: ''
            }
        },
        created() {
            this.gameId = this.$route.params.id;
            this.lobbyId = this.$route.params.lobbyId || null;
            this.pageLoader = false;
        },
        watch: {
            '$route' (to, from) {
                if (to.params.id != from.params.id || to.params.lobbyId) {
                    this.pageLoader = true;
                    setTimeout(() => {
                        this.gameId = this.$route.params.id;
                        this.lobbyId = this.$route.params.lobbyId || null;
                        this.pageLoader = false;
                        this.$router.push({
                            name: 'game',
                            params: {
                                id: this.gameId
                            }
                        });                      
                    }, 300);                    
                }
            }
        },
        methods: {
            toggleFullscreen() {
                if (this.fullScreen) {
                    this.fullScreen = false;
                    document.getElementsByTagName('body')[0].classList.remove('scroll-fix');
                } else {
                    this.fullScreen = true;
                    document.getElementsByTagName('body')[0].classList.add('scroll-fix');
                }
            },
            getSrc() {
                let src = '/games/' + this.urls[this.gameId] + '/';
                if (this.lobbyId) {
                    src = src + '#/' + this.lobbyId + '/';
                }
                return src;
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '~@/assets/styles/pages/_game';
</style>